import * as z from 'zod';

const EMAIL_PATTERN = /^[a-z0-9!$&*.=^`|~#%'+/?_{}-]+@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
export const emailSchema = z.email({ pattern: EMAIL_PATTERN });
